import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { OfferRequest, OfferResponse, OfferPriceResponse } from './models/offer-models';

@Injectable({
  providedIn: 'root'
})
export class RaApi {
  private baseUrl = `${environment.apiBaseURL}/intake`;

  constructor(private http: HttpClient) {}

  processVehicle(request: OfferRequest): Observable<OfferResponse> {
    return this.http.post<OfferResponse>(`${this.baseUrl}/vehicle`, request);
  }

  processOwnership(offerId: string, request: OfferRequest): Observable<OfferResponse> {
    return this.http.post<OfferResponse>(`${this.baseUrl}/${offerId}/ownership`, request);
  }

  processTitle(offerId: string, request: OfferRequest): Observable<OfferResponse> {
    return this.http.post<OfferResponse>(`${this.baseUrl}/${offerId}/title`, request);
  }

  processDamage(offerId: string, request: OfferRequest): Observable<OfferResponse> {
    return this.http.post<OfferResponse>(`${this.baseUrl}/${offerId}/damage`, request);
  }

  processSeller(offerId: string, request: OfferRequest): Observable<OfferPriceResponse> {
    return this.http.post<OfferPriceResponse>(`${this.baseUrl}/${offerId}/seller`, request);
  }

  processPickup(offerId: string, request: OfferRequest): Observable<OfferResponse> {
    return this.http.post<OfferResponse>(`${this.baseUrl}/${offerId}/pickup`, request);
  }

  processAssignment(offerId: string, request: OfferRequest): Observable<OfferResponse> {
    return this.http.post<OfferResponse>(`${this.baseUrl}/${offerId}/assign`, request);
  }
}
